




import Vue from "vue"
import CProjectSearchList from "~/components/custom/projectList/CProjectSearchList.vue"

export default Vue.extend({
  components: {
    CProjectSearchList,
  },
  layout: "application",
  head() {
    return this.$clHelpers.metaTag.generate({
      title: "プロジェクト一覧",
      currentPath: this.$nuxt.$route.path,
    })
  },
  created() {
    this.$clStores.mobileNavigationMenu.actions.changeState({
      pageTitle: "プロジェクト",
      isVisibleBottomNav: true,
    })
  },
})
